export default __webpack_public_path__ + "static/096-f81c8db45ee83767fa23e27638d0249a.jpg";